import { useState, useEffect } from 'react';

/**
 * Detect mobile viewport (≤768px). Updates live on resize.
 */
export function useIsMobile(breakpoint = 768) {
  const readOverride = () => {
    if (typeof window === 'undefined') return null;
    try {
      const q = new URLSearchParams(window.location.search).get('mobile');
      if (q === '1') { localStorage.setItem('wfp_force_mobile', '1'); return true; }
      if (q === '0') { localStorage.removeItem('wfp_force_mobile'); return false; }
      if (localStorage.getItem('wfp_force_mobile') === '1') return true;
    } catch { /* ignore */ }
    return null;
  };

  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    const override = readOverride();
    if (override !== null) return override;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    const handler = () => {
      const override = readOverride();
      if (override !== null) { setIsMobile(override); return; }
      setIsMobile(window.innerWidth <= breakpoint);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [breakpoint]);

  return isMobile;
}
